var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35.2,
    height: 32,
    viewBox: "0 0 35.2 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.896a4.4 4.4 0 0 1 4.4-4.4h23.2a4.4 4.4 0 0 1 4.4 4.4v9.696a10.4 10.4 0 0 0-16.804 11.504H4.4a4.4 4.4 0 0 1-4.4-4.4v-16.8Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M19.896 18.006a3.274 3.274 0 0 0-.116-1.37l-.356-1.178a9.616 9.616 0 0 1 2.678-1.568l.9.902c.336.338.742.608 1.194.79a3.772 3.772 0 0 0 2.848 0 3.585 3.585 0 0 0 1.196-.79l.89-.892c.98.384 1.886.918 2.68 1.586l-.336 1.082a3.274 3.274 0 0 0 .336 2.692c.244.404.572.754.964 1.034.394.278.84.478 1.316.588l.976.224a9.347 9.347 0 0 1 .01 3.104l-1.054.248a3.708 3.708 0 0 0-1.304.59 3.498 3.498 0 0 0-.956 1.028c-.242.4-.398.844-.456 1.302a3.248 3.248 0 0 0 .116 1.368l.356 1.178a9.634 9.634 0 0 1-2.678 1.568l-.9-.9a3.62 3.62 0 0 0-1.194-.79 3.772 3.772 0 0 0-2.848 0 3.618 3.618 0 0 0-1.194.79l-.892.89a9.612 9.612 0 0 1-2.68-1.582l.34-1.084a3.276 3.276 0 0 0-.338-2.69 3.498 3.498 0 0 0-.966-1.036 3.698 3.698 0 0 0-1.316-.588l-.976-.224a9.366 9.366 0 0 1-.01-3.104l1.054-.246a3.696 3.696 0 0 0 1.304-.59 3.504 3.504 0 0 0 .956-1.028 3.296 3.296 0 0 0 .456-1.302Zm3.084 4.686c0 1.422 1.174 2.576 2.62 2.576s2.62-1.154 2.62-2.576c0-1.424-1.174-2.576-2.62-2.576s-2.62 1.152-2.62 2.576Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.afdb5702.svg";
export { ForwardRef as ReactComponent };